<template>
    <div>
        <card-header title="Conferences" icon="fa-presentation"/>

        <card-toolbar>
            <button @click="$openCard('new-conference', {}, card)"><i class="far fa-plus"></i>New Conference</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <search-list-item/>
                <template v-if="featuredConfs.length">
                    <subheader-list-item title="Highlighted Conferences" icon="fa-presentation" :badge="featuredConfs.length"/>
                    <conference-tile
                        v-for="conf in featuredConfs"
                        :card="card"
                        :conf="conf"
                        :active="(child && child.definition.component === 'conference' && conf.id === parseInt(child.props.confId))"
                        @click="$openCard('conference', {confId: conf.id}, card)"
                    />
                </template>
                <template v-if="activeConfs.length">
                    <subheader-list-item title="Active Conferences" icon="fa-presentation" :badge="activeConfs.length"/>
                    <conference-tile
                        v-for="conf in activeConfs"
                        :card="card"
                        :conf="conf"
                        :active="(child && child.definition.component === 'conference' && conf.id === parseInt(child.props.confId))"
                        @click="$openCard('conference', {confId: conf.id}, card)"
                    />
                </template>
                <template>
                    <subheader-list-item title="Conferences" icon="fa-presentation" :badge="inactiveConfs.length"/>
                    <conference-tile
                        v-for="conf in inactiveConfs"
                        :card="card"
                        :conf="conf"
                        :active="(child && child.definition.component === 'conference' && conf.id === parseInt(child.props.confId))"
                        @click="$openCard('conference', {confId: conf.id}, card)"
                    />
                </template>

            </card-list>
        </card-body>

        <card-footer>
            <strong>Total Conferences:</strong> {{conferences.length}}
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import {client as http} from '../../http_client';
    import ConferenceTile from "../../components/tiles/ConferenceTile";

    import moment from "moment";

    export default {
        props: ['card', 'child'],
        components: {ConferenceTile, CardFooter, CardToolbar, CardHeader, CardBody, CardList, SearchListItem, SubheaderListItem},
        data() {
            return {
                conferences: []
            };
        },
        computed: {
            featuredConfs: function() {
                return this.conferences.filter(conf => {
                    return conf.is_highlighted;
                }).sort((a, b) => {
                    return moment(b.start_at).diff(moment(a.start_at));
                });

            },
            activeConfs: function() {
                return this.conferences.filter(conf => {
                    return (moment().isAfter(conf.start_at) && moment().isBefore(conf.end_at) || moment().isBefore(conf.start_at));
                }).sort((a, b) => {
                    return moment(b.start_at).diff(moment(a.start_at));
                });
            },
            inactiveConfs: function() {
                return this.conferences.filter(conf => {
                    return !((moment().isAfter(conf.start_at) && moment().isBefore(conf.end_at)) || moment().isBefore(conf.start_at));
                }).sort((a, b) => {
                    return moment(b.start_at).diff(moment(a.start_at));
                });
            }
        },
        methods: {
            loadConferences: function(force) {
                this.$emit('loading', true);
                http.get('conferences/', {force}).then(response => {
                    this.conferences = response.data;
                    this.$emit('loading', false);
                });
            },
            reload: function() {
                this.loadConferences(true);
            }
        },
        mounted: function() {
            this.loadConferences();
        }
    };
</script>
